import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const B2BEcom = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />

			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/b2b-ecommerce-website-development.jpg')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					B2B E-Commerce Website Development
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					B2B E-Commerce Website Development
				</h6>
			</div>

			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					B2B E-Commerce Website Development
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/b2b2-ecommerce.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								B2B E-Commerce portal is the online platform on which the items
								are sale from one organization to n number of another
								organizations. Basically, it's the point at which a Business
								Organization has an online web store and sells its items or
								goods on that webpage only to another business organizations.
								B2B E-Commerce portal does not a direct customer or end user
								allow to shop. Only registered users can order item from here in
								a bulk number. B2B E-Commerce portal is an online business model
								for purchasing, selling and promoting services or products with
								live inventory details, price, availability etc.
							</p>
							<br />
							<p>
								Now, by using B2B login a Retailer can easily order goods as per
								his/her demand to Wholesaler or company without spending time
								and money in travel and no need to wait for hours at wholesaler
								godown or company outlet.
							</p>

							<br />
							<p>
								As our team have 10+ years great experience in software
								development so we provides advance technology enabled B2B
								E-Commerce portal online solution. By using this Online Solution
								not only you but your Sub Agent will also grow their business.
							</p>

							<br />
							<p>
								To avoid system or office dependency we develop a fully
								responsive and device friendly user interface. Any B2B user can
								login from Mobile as well and can make orders and uses the
								services without interruption. Arya Aviation provides unlimited
								bandwidth so n number of user can access system at same time and
								use services quickly. Our user friendly interface and easy to
								use B2B module system provides seamless services So if you are
								having a business and you are working offline you must develop
								your Online E-Commerce Portal with Arya Aviation.
							</p>
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default B2BEcom;
